export const Designations = [
  {
    id: 'Dr.',
    name: 'Dr.',
  },
  {
    id: 'Prof.',
    name: 'Prof.',
  },
  {
    id: 'Mr.',
    name: 'Mr.',
  },
  {
    id: 'Ms.',
    name: 'Ms.',
  },
  {
    id: 'Mrs.',
    name: 'Mrs.',
  },
]

export const Prefix = [
  {
    id: 'Mr.',
    name: 'Mr.',
  },
  {
    id: 'Ms.',
    name: 'Ms.',
  },
  {
    id: 'Mrs.',
    name: 'Mrs.',
  },
]

export const NewsPriority = [
  {
    id: 'Normal',
    name: 'Normal',
  },
  {
    id: 'High',
    name: 'High Priority',
  },
]

export const EvTypes = [
  {
    id: 'academic_year',
    name: 'Academic Year',
  },
  {
    id: 'semester',
    name: 'Semester',
  },
  {
    id: 'program',
    name: 'Programme',
  },
  {
    id: 'course',
    name: 'Course',
  },
]

export const EvTypesFr = [
  {
    id: 'academic_year',
    name: 'Année académique',
  },
  {
    id: 'semester',
    name: 'Semestre',
  },
  {
    id: 'program',
    name: 'Programme',
  },
  {
    id: 'course',
    name: 'Cours',
  },
]

export const Regions = [
  {
    id: 'Africa',
    name: 'Africa',
  },
  {
    id: 'America',
    name: 'America',
  },
  {
    id: 'Antarctica',
    name: 'Antarctica',
  },
  {
    id: 'Asia',
    name: 'Asia',
  },
  {
    id: 'Europe',
    name: 'Europe',
  },
  {
    id: 'Oceania',
    name: 'Oceania',
  },
]

export const SponsorType = [
  {
    id: 'Affectés',
    name: 'Affecté',
  },
  {
    id: 'Pensionnaires',
    name: 'Pensionnaire',
  },
]

export const StudySponsor = [
  {
    id: 'Self',
    name: 'Myself',
  },
  {
    id: 'Parents',
    name: 'My Parents or Family',
  },
  {
    id: 'My Employer',
    name: 'My Employer',
  },
  {
    id: 'Organization',
    name: 'An Organization or Institution',
  },
  {
    id: 'Other',
    name: 'Other',
  },
]

export const StudySponsorFr = [
  {
    id: 'Self',
    name: 'Moi-même',
  },
  {
    id: 'Parents',
    name: 'Mes parents ou ma famille',
  },
  {
    id: 'My Employer',
    name: 'Mon employeur',
  },
  {
    id: 'Organization',
    name: 'Une organisation ou une institution',
  },
  {
    id: 'Other',
    name: 'Autre',
  },
]

export const ContractTypes = [
  {
    id: 'Permanent',
    name: 'Permanent',
  },
  {
    id: 'Contract Base',
    name: 'Adjunct Faculty',
  },
]

export const ContractTypesFr = [
  {
    id: 'Permanent',
    name: 'Permanent',
  },
  {
    id: 'Contract Base',
    name: 'Vacataire',
  },
]

export const StudentStatus = [
  {
    id: 'Candidate',
    name: 'Candidate',
  },
  {
    id: 'Student',
    name: 'Student',
  },
]

export const LecturerDocumentTypes = [
  {
    id: 'ID Card | Passport',
    name: 'ID Card | Passport',
  },
  {
    id: 'Diploma',
    name: 'Diploma',
  },

  {
    id: 'CV',
    name: 'CV',
  },
  {
    id: 'document',
    name: 'Document',
  },

  {
    id: 'Others',
    name: 'Other',
  },
]

export const LecturerDocumentTypesFr = [
  {
    id: 'ID Card | Passport',
    name: 'Carte d’identité | Passeport',
  },
  {
    id: 'Diploma',
    name: 'Diplôme',
  },
  {
    id: 'CV',
    name: 'CV',
  },
  {
    id: 'Document',
    name: 'Document',
  },
  {
    id: 'Others',
    name: 'Autre',
  },
]

export const RegulationTypes = [
  {
    id: 'Student',
    name: 'Student',
  },
  {
    id: 'Lecturer',
    name: 'Lecturer',
  },
  {
    id: 'General',
    name: 'General',
  },
]

export const VideoTypes = [
  {
    id: 'All',
    name: 'All',
  },
  {
    id: 'All Students',
    name: 'All Students',
  },
  {
    id: 'All Lecturers',
    name: 'All Lecturers',
  },
  {
    id: 'Student',
    name: 'Student',
  },
  {
    id: 'Lecturer',
    name: 'Lecturer',
  },
]

export const PublicationFor = [
  {
    id: 'Student',
    name: 'Student',
  },
  {
    id: 'Lecturer',
    name: 'Lecturer',
  },
]

export const DynamicValues = [
  {
    name: '__surname__',
  },
  {
    name: '__name__',
  },
  {
    name: '__address__',
  },
  {
    name: '__city__',
  },
  {
    name: '__country__',
  },
  {
    name: '__birth_date__',
  },
  {
    name: '__nationality__',
  },
  {
    name: '__reg_no__',
  },
  {
    name: '__program__',
  },
  {
    name: '__campus__',
  },
  {
    name: '__registration_fee__',
  },
  {
    name: '__admission_fee__',
  },
  {
    name: '__study_fee__',
  },
  {
    name: '__administrative_director__',
  },
  {
    name: '__academic_year__',
  },
  {
    name: '__bank__',
  },
  {
    name: '__bank_name__',
  },
  {
    name: '__iban__',
  },
  {
    name: '__swift_bic__',
  },
  {
    name: '__academic_year_begin__',
  },
  {
    name: '__current_date__',
  },
]

export const PaymentMethods = [
  {
    id: 'Bank',
    name: 'Bank',
  },
  {
    id: 'Cash',
    name: 'Cash',
  },
  {
    id: 'Check',
    name: 'Check',
  },
  {
    id: 'Other',
    name: 'Other',
  },
]

export const InvoiceTypes = [
  {
    id: 'Admission Fee',
    name: 'Admission Fee',
  },
  {
    id: 'Study Fee',
    name: 'Study Fee',
  },
  {
    id: 'Invoice',
    name: 'Other fees',
  },
]
export const InvoiceTypesFr = [
  {
    id: 'Admission Fee',
    name: 'Frais d’inscription',
  },
  {
    id: 'Study Fee',
    name: 'Frais de scolarité',
  },
  {
    id: 'Invoice',
    name: 'Autre frais',
  },
]

export const FormFor = [
  {
    id: 'Student',
    name: 'Student',
  },
  {
    id: 'Lecturer',
    name: 'Lecturer',
  },
  {
    id: 'Alumni',
    name: 'Alumni',
  },
]

export const Type = [
  {
    id: 'Facture',
    name: 'Facture',
  },
  {
    id: 'Preforma',
    name: 'Preforma Facture',
  },
]

export const FormOptions = [
  {
    id: 'CheckBox',
    name: 'CheckBox',
  },
  {
    id: 'Radio Button',
    name: 'Radio Button',
  },
  {
    id: 'Text',
    name: 'Text',
  },
  {
    id: 'Rate',
    name: 'Rate',
  },
]

export const CourseMaterialTypes = [
  {
    id: 'Syllabus',
    name: 'Syllabus',
  },
  {
    id: 'PowerPoint/ Book/ Article/ Note',
    name: 'PowerPoint/ Book/ Article/ Note',
  },
  {
    id: 'Video',
    name: 'Video',
  },
  {
    id: 'Link',
    name: 'Link',
  },
  {
    id: 'Assignment',
    name: 'Assignment',
  },
]

export const AssginmentTypes = [
  {
    id: 'Exercise',
    name: 'Exercise',
  },
  {
    id: 'Midterm',
    name: 'Midterm',
  },
  {
    id: 'Final',
    name: 'Final',
  },
  {
    id: 'Midterm and Final',
    name: 'Midterm and Final',
  },
]

export const NewsTypes = [
  {
    id: 'General',
    name: 'General',
  },
  {
    id: 'All Lecturers',
    name: 'All Lecturers',
  },
  {
    id: 'Planning Academic Year',
    name: 'Planning Academic Year (Lecturer)',
  },
  {
    id: 'Planning Semester',
    name: 'Planning Semester (Lecturer)',
  },
  {
    id: 'Planning Program',
    name: 'Planning Programme (Lecturer)',
  },
  {
    id: 'All Students',
    name: 'All Students',
  },
  {
    id: 'Bachelor',
    name: 'Bachelor',
  },
  {
    id: 'Master',
    name: 'Master',
  },
  {
    id: 'Lecturer',
    name: 'Lecturer',
  },
  {
    id: 'Student',
    name: 'Student',
  },
  {
    id: 'Program',
    name: 'Programme',
  },
  {
    id: 'Class',
    name: 'Class',
  },
  {
    id: 'Course',
    name: 'Course',
  },
  {
    id: 'Alumni',
    name: 'Alumni',
  },
  {
    id: 'Academic Year',
    name: 'Academic Year',
  },
  {
    id: 'Semester',
    name: 'Semester',
  },
  {
    id: 'Kankor Students',
    name: 'Kankor Students',
  },
]

export const AttendanceTypes = [
  {
    id: 'P',
    name: 'P',
  },
  {
    id: 'A',
    name: 'A',
  },
  {
    id: 'AJ',
    name: 'AJ',
  },
  {
    id: 'L',
    name: 'L',
  },
]

export const getCurrentDate = (): string => {
  const date = new Date()
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0') // Months are 0-based
  const year = date.getFullYear()
  return `${day}-${month}-${year}`
}

export const classTypes = [
  {
    id: 'Normal',
    name: 'Normal',
  },
  {
    id: 'Online',
    name: 'Online',
  },
]

export const paymentMethods = [
  {
    id: 'Salary',
    name: 'Employee',
  },
  {
    id: 'Independant',
    name: 'Self-employed',
  },
]

export const paymentMethodsFr = [
  {
    id: 'Salary',
    name: 'Salarié',
  },
  {
    id: 'Independant',
    name: 'Indépendant ',
  },
]

export const paymentTypes = [
  {
    id: 'monthly',
    name: 'Monthly',
  },
  {
    id: 'daily',
    name: 'Daily',
  },
  {
    id: 'hourly',
    name: 'Hourly',
  },
]

export const paymentTypesFr = [
  {
    id: 'monthly',
    name: 'Mensuel',
  },
  {
    id: 'daily',
    name: 'Journalier',
  },
  {
    id: 'hourly',
    name: 'Horaire',
  },
]

export const ContractStatus = [
  {
    id: 'pending',
    name: 'pending',
  },
  {
    id: 'signed',
    name: 'signed',
  },
  {
    id: 'approved',
    name: 'approved',
  },
]

export const InvoiceStatus = [
  {
    id: 'Paid',
    name: 'Paid',
  },
  {
    id: 'Partially Paid',
    name: 'Partially Paid',
  },
  {
    id: 'Remain',
    name: 'Remain',
  },
]

export const reportPaymentOptions = [
  {
    id: 'All',
    name: 'All',
  },
  {
    id: 'Paid',
    name: 'Paid',
  },
  {
    id: 'Due',
    name: 'Due',
  },
  {
    id: 'Late Payment',
    name: 'Unpaid',
  },
]

export const studyMode = [
  {
    id: 'OFFLINE',
    name: 'I would like to attend my program on campus.',
  },
  {
    id: 'ONLINE',
    name: 'I would like to follow my program online.',
  },
]

export const studyModeFr = [
  {
    id: 'OFFLINE',
    name: 'Je souhaite suivre ma formation en présentiel.',
  },
  {
    id: 'ONLINE',
    name: 'Je souhaite suivre ma formation en ligne.',
  },
]

export const hearAbout = [
  {
    id: 'Google/Web search',
    name: 'Google/Web search',
  },
  {
    id: 'Facebook',
    name: 'Facebook',
  },
  {
    id: 'Instagram',
    name: 'Instagram',
  },
  {
    id: 'YouTube',
    name: 'YouTube',
  },
  {
    id: 'LinkedIn',
    name: 'LinkedIn',
  },
  {
    id: 'TikTok',
    name: 'TikTok',
  },
  {
    id: 'Offline Advertising',
    name: 'Offline Advertising (billboards/posters, flyers, radio, TV, press)',
  },
  {
    id: 'SWISS UMEF website',
    name: 'SWISS UMEF website',
  },
  {
    id: 'Recommendation',
    name: 'Recommendation (friends, family, colleagues)',
  },
  {
    id: 'Student/Alumni',
    name: 'Student/Alumni',
  },
  {
    id: 'Fair/event',
    name: 'Fair/event (student fair, forum, open day, conference)',
  },
  {
    id: 'Partner/school/institution',
    name: 'Partner/school/institution',
  },
  {
    id: 'Company/employer',
    name: 'Company/employer',
  },
  {
    id: 'WhatsApp/Telegram/SMS',
    name: 'WhatsApp/Telegram/SMS',
  },
  {
    id: 'Others',
    name: 'Others',
  },
]

export const ResultType = [
  {
    id: 'All',
    name: 'All',
  },
  {
    id: 'Success',
    name: 'Passed',
  },
  {
    id: 'Redo',
    name: 'Course Redo Required',
  },
  {
    id: 'Retake',
    name: 'Exam Retake Required',
  },
  {
    id: 'Redo_Retake',
    name: 'Course Redo and Exam Retake Required',
  },
]

export const ResultTypeFr = [
  {
    id: 'All',
    name: 'Tous',
  },
  {
    id: 'Success',
    name: 'Réussi',
  },
  {
    id: 'Redo',
    name: 'Cours à refaire',
  },
  {
    id: 'Retake',
    name: 'Examen à repasser',
  },
  {
    id: 'Redo_Retake',
    name: 'Cours à refaire et examen à repasser',
  },
]

export const AttTypes = [
  {
    id: 'academic_year',
    name: 'Academic Year',
  },
  {
    id: 'semester',
    name: 'Semester',
  },
  {
    id: 'program',
    name: 'Programme',
  },
  {
    id: 'course',
    name: 'Course',
  },
  {
    id: 'student',
    name: 'Student',
  },
]

export const AttTypesFr = [
  {
    id: 'academic_year',
    name: 'Année académique',
  },
  {
    id: 'semester',
    name: 'Semestre',
  },
  {
    id: 'program',
    name: 'Programme',
  },
  {
    id: 'course',
    name: 'Cours',
  },
  {
    id: 'student',
    name: 'Étudiant',
  },
]

export const ExPaperType = [
  {
    id: 'Written Exam',
    name: 'Written Exam',
  },
  {
    id: 'Research Project',
    name: 'Research Project',
  },
  {
    id: 'Group Project',
    name: 'Group Project',
  },
  {
    id: 'Others',
    name: 'Other',
  },
]

export const ExPaperTypeFr = [
  {
    id: 'Written Exam',
    name: 'Examen écrit',
  },
  {
    id: 'Research Project',
    name: 'Projet de recherche',
  },
  {
    id: 'Group Project',
    name: 'Projet de groupe',
  },
  {
    id: 'Others',
    name: 'Autre',
  },
]

export const Relations = [
  {id: 'Father', name: 'Father'},
  {id: 'Mother', name: 'Mother'},
  {id: 'Brother', name: 'Brother'},
  {id: 'Sister', name: 'Sister'},
  {id: 'Husband', name: 'Husband'},
  {id: 'Wife', name: 'Wife'},
  {id: 'Guardian', name: 'Guardian'},
  {id: 'Uncle', name: 'Uncle'},
  {id: 'Aunt', name: 'Aunt'},
  {id: 'Friend', name: 'Friend'},
  {id: 'Colleague', name: 'Colleague'},
  {id: 'Other', name: 'Other'},
]

export const RelationsFr = [
  {id: 'Father', name: 'Père'},
  {id: 'Mother', name: 'Mère'},
  {id: 'Brother', name: 'Frère'},
  {id: 'Sister', name: 'Sœur'},
  {id: 'Husband', name: 'Mari'},
  {id: 'Wife', name: 'Épouse'},
  {id: 'Guardian', name: 'Tuteur / Tutrice'},
  {id: 'Uncle', name: 'Oncle'},
  {id: 'Aunt', name: 'Tante'},
  {id: 'Friend', name: 'Ami(e)'},
  {id: 'Colleague', name: 'Collègue'},
  {id: 'Other', name: 'Autre'},
]

export const RecordsNo = [
  {id: '20', name: '20'},
  {id: '50', name: '50'},
  {id: '75', name: '75'},
  {id: '100', name: '100'},
]

export const InvoiceOptions = [
  {id: 'YES', name: 'Invoiced'},
  {id: 'NO', name: 'Not Invoiced'},
]

export const InvoiceOptionsFr = [
  {id: 'YES', name: 'Facturé'},
  {id: 'NO', name: 'Non facturé'},
]

export const StudentType = [
  {id: 'New', name: 'New Student'},
  {id: 'Transferred', name: 'Transferred Student'},
]

export const StudentTypeFr = [
  {id: 'New', name: 'Nouvel étudiant'},
  {id: 'Transferred', name: 'Étudiant transféré'},
]

export const courseTranscriptOptions = [
  {id: 'YES', name: 'Yes'},
  {id: 'NO', name: 'No'},
]

export const courseTranscriptOptionsFr = [
  {id: 'YES', name: 'Oui'},
  {id: 'NO', name: 'Non'},
]

export const ExPaperSearchOpts = [
  {
    id: 'academic_year',
    name: 'Academic Year',
  },
  {
    id: 'semester',
    name: 'Semester',
  },
  {
    id: 'program',
    name: 'Programme',
  },
  {
    id: 'course',
    name: 'Course',
  },
]

export const ExPaperSearchOptsFr = [
  {
    id: 'academic_year',
    name: 'Année académique',
  },
  {
    id: 'semester',
    name: 'Semestre',
  },
  {
    id: 'program',
    name: 'Programme',
  },
  {
    id: 'course',
    name: 'Cours',
  },
]

export const MeetingType = [
  {
    id: 'Online',
    name: 'Online',
  },
  {
    id: 'Offline',
    name: 'In Person',
  },
]

export const MeetingTypeFr = [
  {
    id: 'Online',
    name: 'En ligne',
  },
  {
    id: 'Offline',
    name: 'En présentiel',
  },
]

export const OnlineMaterialTypes = [
  {
    id: 'PowerPoint/ Book/ Article/ Note',
    name: 'PowerPoint/ Book/ Article/ Note',
  },
  {
    id: 'Video',
    name: 'Video',
  },
  {
    id: 'Link',
    name: 'Link',
  },
  {
    id: 'Assignment',
    name: 'Assignment',
  },
]

export const ExamTypes = [
  {
    id: 'Midterm',
    name: 'Midterm Exam',
  },
  {
    id: 'Final',
    name: 'Final Exam',
  },
  {
    id: 'Midterm and Final',
    name: 'Midterm and Final Exam',
  },
  {
    id: 'Final (Project)',
    name: 'Final Exam (Project)',
  },
  {
    id: 'Exercise',
    name: 'Exercise',
  },
]

export const ExamTypesFr = [
  {
    id: 'Midterm',
    name: 'Examen intermédiaire',
  },
  {
    id: 'Final',
    name: 'Examen final',
  },
  {
    id: 'Midterm and Final',
    name: 'Examen intermédiaire et final',
  },
  {
    id: 'Final (Project)',
    name: 'Examen final (project)',
  },
  {
    id: 'Exercise',
    name: 'Exercise',
  },
]

export const QuestionTypes = [
  {
    id: 'single_choice',
    name: 'Single Choice',
    icon: 'fa-regular fa-circle',
  },
  {
    id: 'multiple_choice',
    name: 'Multiple Choice',
    icon: 'fa fa-list-ul',
  },
  {
    id: 'true_false',
    name: 'True / False',
    icon: 'fa fa-ellipsis',
  },
  {
    id: 'matching',
    name: 'Matching',
    icon: 'fa fa-list-check',
  },
  {
    id: 'case_study',
    name: 'Case Study',
    icon: 'fa fa-book-open',
  },
  {
    id: 'essay',
    name: 'Short-answer Question',
    icon: 'fa fa-pencil-alt',
  },
  {
    id: 'motivation_letter',
    name: 'Motivation Letter',
    icon: 'fa fa-lightbulb',
  },
]

export const LecTypes = [
  {
    id: 'Online',
    name: 'Online',
  },
  {
    id: 'Offline',
    name: 'Offline',
  },
]

export const formatNumber = (num: any) => Number(num || 0).toFixed(2)

export const TranscriptTypes = [
  {
    id: 'Academic Year',
    name: 'Academic Year',
  },
  {
    id: 'Semester',
    name: 'Semester',
  },
  {
    id: 'Class',
    name: 'Class',
  },
  {
    id: 'Students',
    name: 'Student(s)',
  },
  {
    id: 'Graduated Students',
    name: 'Graduated Students',
  },
  {
    id: 'Completed Credits',
    name: 'Completed Credits',
  },
  {
    id: 'Pending Courses',
    name: 'Pending Courses',
  },
]

export const TranscriptTypesFr = [
  {
    id: 'Academic Year',
    name: 'Année académique',
  },
  {
    id: 'Semester',
    name: 'Semestre',
  },
  {
    id: 'Class',
    name: 'Classe',
  },
  {
    id: 'Students',
    name: 'Étudiant(s)',
  },
  {
    id: 'Graduated Students',
    name: 'Étudiants diplômés',
  },
  {
    id: 'Completed Credits',
    name: 'Étudiants ayant validé tous les crédits',
  },
  {
    id: 'Pending Courses',
    name: 'Étudiants avec cours à compléter',
  },
]

export const ParticipantType = [
  {
    id: 'Student',
    name: 'Student',
  },
  {
    id: 'Manager',
    name: 'Course Manager',
  },
  {
    id: 'Admin',
    name: 'Course Admin',
  },
  {
    id: 'Online Student',
    name: 'Online Student',
  },
]

export const ParticipantTypeFr = [
  {
    id: 'Student',
    name: 'Étudiant',
  },
  {
    id: 'Manager',
    name: 'Responsable de cours',
  },
  {
    id: 'Admin',
    name: 'Administrateur de cours',
  },
  {
    id: 'Online Student',
    name: 'Étudiant en ligne',
  },
]

export const LessionSessions = [
  {
    id: 1,
    name: 1,
  },
  {
    id: 2,
    name: 2,
  },
  {
    id: 3,
    name: 3,
  },
  {
    id: 4,
    name: 4,
  },
  {
    id: 5,
    name: 5,
  },
  {
    id: 6,
    name: 6,
  },
]

export const CourseType = [
  {
    id: 'Normal',
    name: 'Normal',
  },
  {
    id: 'Continuing Education',
    name: 'Continuing Education',
  },
]
export const CourseTypeFr = [
  {
    id: 'Normal',
    name: 'Normal',
  },
  {
    id: 'Continuing Education',
    name: 'Formation continue',
  },
]

export const Genders = [
  {
    id: 1,
    name: 'Male',
  },
  {
    id: 2,
    name: 'Female',
  },
]
export const GendersFr = [
  {
    id: 1,
    name: 'Masculin',
  },
  {
    id: 2,
    name: 'Féminin',
  },
]

export const EntranceXmType = [
  {
    id: 'Entrance',
    name: 'Kankor',
  },
  {
    id: 'Student',
    name: 'Students',
  },
  {
    id: 'Application',
    name: 'Applications',
  },
]
export const EntranceXmTypeFr = [
  {
    id: 'Entrance',
    name: 'Entrance',
  },
  {
    id: 'Student',
    name: 'Étudiants',
  },
  {
    id: 'Application',
    name: 'Candidatures',
  },
]
